import { GsFormSchema } from '../../../components';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { SPACING_SCHEMA } from './spacing.schema';

export const HASNODEBITCARD_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [...BASIC_SCHEMA_FIELDS, ...SPACING_SCHEMA]
};
